<template>
  <ElTable
    :data="data"
    row-key="token"
    cell-class-name="alpha-table__cell"
    class="alpha-table"
    @row-click="handleRowClick"
  >
    <ElTableColumn min-width="100" :label="$t('GROUP_NAME')">
      <template slot-scope="{ row: { name } }">
        {{ name }}
      </template>
    </ElTableColumn>
    <ElTableColumn min-width="100" :label="$t('CREATED_DATE')">
      <template slot-scope="{ row: { updated } }">
        {{ translateDate(updated, lang) }}
      </template>
    </ElTableColumn>
    <ElTableColumn min-width="100" :label="$t('MEMBER_COUNT')">
      <template slot-scope="{ row: { memberCount } }">
        {{ memberCount }}
      </template>
    </ElTableColumn>
    <ElTableColumn max-width="10">
      <template slot-scope="{ row: { id } }">
        <div class="alpha-table__actions">
          <ElButton
            type="default"
            size="mini"
            class="alpha-table__edit-btn"
            @click.stop="editGroup(id)"
          >
            ویرایش
          </ElButton>
          <ElButton
            type="danger"
            :plain="true"
            size="mini"
            icon="el-icon-delete"
            class="alpha-table__delete-btn"
            @click.stop="deleteGroup(id)"
          />
        </div>
      </template>
    </ElTableColumn>
  </ElTable>
</template>

<script>
import { translateDate } from '@/utils/date';
import lang from '@/mixins/lang';

export default {
  name: 'AlphaTable',
  mixins: [lang],
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    translateDate,
    editGroup(groupId) {
      this.$emit('edit', groupId);
    },
    deleteGroup(groupId) {
      this.$emit('delete', groupId);
    },
    handleRowClick(row) {
      this.$router.push({
        name: 'app-releases-group-detail',
        params: {
          groupId: row.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.alpha-table {
  &__cell {
    border-bottom: 0 !important;
  }

  &__button {
    margin-left: calc($global-margin / 2) !important;

    @include rtl() {
      margin-left: 0 !important;
      margin-right: calc($global-margin / 2);
    }
  }

  &__edit.is-disabled,
  &__edit.is-disabled:hover {
    color: color.scale($lb-lighter-gray, $lightness: -20%) !important;
    border-color: color.scale($lb-lighter-gray, $lightness: -20%) !important;
    background: transparent !important;
  }

  @include breakpoint(medium down) {
    &__edit > span {
      display: none;
    }
  }

  .el-table {
    &__row {
      cursor: pointer;
      transition: background-color 0.2s ease;
      &:hover {
        background-color: #f5f7fa;
      }
      &--no-expand .el-table__expand-icon {
        display: none;
      }

      &.expanded {
        background: $--background-color-base;
      }
    }

    &__auto-publish.el-switch__label span {
      font-size: rem-calc(11);
      margin-right: $global-margin;
    }

    &__expanded-cell {
      padding: 0 !important;
    }
  }
}
</style>
